import axios from "axios";
import { APIURLS } from "./Config";
// import { ToastNotifier } from "../ui/ToastNotifier";
import { removeItem } from "../cookie/Cookie";
import { ToastNotifier } from "../../components/ui/ToastNotifier";
const api = axios.create({ baseURL: APIURLS.baseUrl });
api.interceptors.response.use(
  (response) => response.data,
  (err) => {
    const status = err.response?.status;
    const errMessage = err?.response?.data?.message;
    try {
      if (status == 403) {
        // removeToken("token");
        // removeItem("application_id");
        // removeItem("role");
        // removeItem("branchID");
        removeItem("token");
        window.location.href = "/";
      } else if (status == 400) {
        ToastNotifier(errMessage, "error");
      } else if (status == 401) {
        // ToastNotifier(errMessage, "error");
      } else if (status == 404) {
        // handle not found
        // window.location.href ='/404'
        // alert("404");
        ToastNotifier(errMessage, "error");
      } else if (status == 500) {
        // alert("500");
      } else if (status == 504) {
        ToastNotifier(
          "The Server took too long to response,Please try again later",
          "error",
        );
      } else {
        ToastNotifier(err.message, "error");
        Promise.reject(err);
      }
    } catch (err) {
      return Promise.reject(err);
    }
  },
);

export default api;
